module.exports = __webpack_public_path__ + "img/1.8153e2e8.png";